import * as React from 'react';
import { Box, Card, CardActions, Button, Typography, Divider } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function CustomCard(props) {
    return (
        <Box sx={{ minWidth: 240, display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100%' }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px', width: '100%', justifyContent: 'space-between' }}>
                <div>
                    <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
                        {props.name}
                    </Typography>
                </div>
                <div>
                    <LazyLoadImage style={{ width: 'auto', maxHeight: '250px', maxWidth: '250px', height: 'auto', margin: '10px 0' }} src={props.image} alt={props.name} />
                </div>
                <div>
                    <Divider variant="middle" className='my-1' sx={{ width: '100%' }} />
                    <Typography variant="body1" className='p-1'>
                        {props.info}
                    </Typography>
                </div>
            </Card>
        </Box>
    );
}